export interface OpsReport {
  id: string;
  title: string;
  type: "daily" | "weekly" | "monthly" | "incident";
  status: "generated" | "pending" | "archived";
  generatedAt: string;
  period: string;
  author: string;
  summary: string;
  deviceOnlineRate: number;
  totalTours: number;
  totalVisitors: number;
  incidentsCount: number;
  avgBatteryHealth: number;
  fileSize: string;
}

export const opsReports: OpsReport[] = [
  {
    id: "rpt-001",
    title: "2026年6月9日 运维日报",
    type: "daily",
    status: "generated",
    generatedAt: "2026-06-09 18:30",
    period: "2026-06-09",
    author: "系统自动生成",
    summary: "今日在线率 96.2%，设备故障 2 台，已完成更换。南津关区域 14:00-15:00 出现短暂信号波动，已排查恢复。全天游客接待量 384 人次，AI 问答 2647 次。",
    deviceOnlineRate: 96.2,
    totalTours: 8,
    totalVisitors: 384,
    incidentsCount: 2,
    avgBatteryHealth: 91.5,
    fileSize: "2.4MB",
  },
  {
    id: "rpt-002",
    title: "2026年6月8日 运维日报",
    type: "daily",
    status: "generated",
    generatedAt: "2026-06-08 18:30",
    period: "2026-06-08",
    author: "系统自动生成",
    summary: "今日在线率 95.8%，设备故障 1 台，外观磕碰送修。屈原故里景区 AP3 凌晨自动重启一次，未影响服务。全天游客接待量 352 人次。",
    deviceOnlineRate: 95.8,
    totalTours: 8,
    totalVisitors: 352,
    incidentsCount: 1,
    avgBatteryHealth: 91.2,
    fileSize: "2.1MB",
  },
  {
    id: "rpt-003",
    title: "2026年第24周 运维周报 (6.1-6.7)",
    type: "weekly",
    status: "generated",
    generatedAt: "2026-06-07 20:00",
    period: "2026-06-01 ~ 2026-06-07",
    author: "张运维",
    summary: "本周设备在线率均值 95.5%，共处理故障设备 8 台，其中 3 台送修、5 台现场修复。完成固件 v3.2.1 推送至 200 台设备，成功率 98%。三游洞新增 AP 1 台，信号覆盖盲区已消除。",
    deviceOnlineRate: 95.5,
    totalTours: 56,
    totalVisitors: 2147,
    incidentsCount: 8,
    avgBatteryHealth: 90.8,
    fileSize: "5.8MB",
  },
  {
    id: "rpt-004",
    title: "2026年第23周 运维周报 (5.25-5.31)",
    type: "weekly",
    status: "archived",
    generatedAt: "2026-05-31 20:00",
    period: "2026-05-25 ~ 2026-05-31",
    author: "张运维",
    summary: "本周设备在线率均值 94.8%，共处理故障设备 6 台。完成黄金周前设备全面体检，更换老化电池 35 块。南津关码头 WiFi 升级至 AX6000-Pro。",
    deviceOnlineRate: 94.8,
    totalTours: 52,
    totalVisitors: 1893,
    incidentsCount: 6,
    avgBatteryHealth: 89.5,
    fileSize: "5.2MB",
  },
  {
    id: "rpt-005",
    title: "2026年5月 运维月报",
    type: "monthly",
    status: "generated",
    generatedAt: "2026-06-01 10:00",
    period: "2026-05-01 ~ 2026-05-31",
    author: "陈运营",
    summary: "5月整体运营平稳，设备在线率月均 94.2%。五一黄金周期间（5.1-5.5）日均游客接待量 580 人次，最高并发在线设备 218 台，系统运行稳定无重大故障。本月新增设备 40 台，退役设备 12 台。完成春季设备大检修，电池健康度回升至 90%+。",
    deviceOnlineRate: 94.2,
    totalTours: 248,
    totalVisitors: 8921,
    incidentsCount: 23,
    avgBatteryHealth: 90.1,
    fileSize: "12.3MB",
  },
  {
    id: "rpt-006",
    title: "2026年4月 运维月报",
    type: "monthly",
    status: "archived",
    generatedAt: "2026-05-01 10:00",
    period: "2026-04-01 ~ 2026-04-30",
    author: "陈运营",
    summary: "4月设备在线率月均 93.8%。清明节小长假游客量增长 30%，西陵峡口临时增派设备 15 台。完成固件 v3.2.0 版本全量推送，新增离线讲解模式。本月故障设备 18 台，较上月下降 15%。",
    deviceOnlineRate: 93.8,
    totalTours: 224,
    totalVisitors: 7654,
    incidentsCount: 18,
    avgBatteryHealth: 88.5,
    fileSize: "11.8MB",
  },
  {
    id: "rpt-007",
    title: "2026年6月5日 南津关信号波动事件报告",
    type: "incident",
    status: "generated",
    generatedAt: "2026-06-05 16:45",
    period: "2026-06-05 14:00-15:00",
    author: "王网络",
    summary: "2026年6月5日 14:00，南津关区域 22 台设备同时出现信号波动，RSSI 降至 -78dBm，持续约 60 分钟。排查发现 AP 信道与附近游轮 WiFi 信号冲突，切换至 CH48 后恢复。影响范围：22 台设备短暂离线，讲解触发延迟增加约 3-5 秒。已制定信道定期扫描计划，避免同类事件。",
    deviceOnlineRate: 0,
    totalTours: 0,
    totalVisitors: 0,
    incidentsCount: 1,
    avgBatteryHealth: 0,
    fileSize: "1.2MB",
  },
  {
    id: "rpt-008",
    title: "2026年5月28日 电池批量更换事件报告",
    type: "incident",
    status: "archived",
    generatedAt: "2026-05-28 17:30",
    period: "2026-05-25 ~ 2026-05-28",
    author: "张运维",
    summary: "5月25日例行巡检发现 35 台设备电池健康度低于 80%，续航不足 6 小时。立即启动批量更换流程，3 天内完成全部更换。更换后平均续航恢复至 9.5 小时。经查，该批次电池为 2025年9月批次，已接近使用寿命末期。已建议缩短该批次巡检周期至每周一次。",
    deviceOnlineRate: 0,
    totalTours: 0,
    totalVisitors: 0,
    incidentsCount: 1,
    avgBatteryHealth: 0,
    fileSize: "0.9MB",
  },
];

export const reportTypeLabels: Record<string, string> = {
  daily: "日报",
  weekly: "周报",
  monthly: "月报",
  incident: "事件报告",
};

export const reportStatusLabels: Record<string, string> = {
  generated: "已生成",
  pending: "生成中",
  archived: "已归档",
};